import { render, staticRenderFns } from "./TermsConfirmModal.vue?vue&type=template&id=b7af6150"
import script from "./TermsConfirmModal.vue?vue&type=script&lang=js"
export * from "./TermsConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports